import React from 'react'
import { StarCount } from '@usap/widgets'
import { CheckWmoIcon, PlusWmoIcon } from '@usap/uicomponents'
import * as Styled from './InstallAtShopInfoCheckoutWmo.css'
import { getInstallAtShopSeeMoreCTAId } from '../utility/anchorUtils'
import InstallAtShopPrice from './InstallAtShopPrice'
import ButtonDifmWmo from './Wmo/ButtonDifmWmo'

interface IInstallAtShopInfoWmo {
  handleToggleInstallation: () => void
  handleChangeInstallation: () => void
  isRppEnabled: boolean
  installPrice: number | null
  installPriceMin: number | null
  installPriceMax: number | null
  shopName: string
  rating: number | null | undefined
  ratingCount: number | null | undefined
  shopAddress: string
  milesToShop: string
  isFirstAvailability: boolean
  // eslint-disable-next-line no-undef
  appointmentDate: JSX.Element
  // eslint-disable-next-line no-undef
  selectButtonLabel: JSX.Element
  isSelected: boolean
  sku: string
  hideActionButtons?: boolean
  ActionsRender?: React.ReactNode
}

const InstallAtShopInfoCheckoutWmo: React.FC<IInstallAtShopInfoWmo> = ({
  handleToggleInstallation,
  handleChangeInstallation,
  isRppEnabled,
  installPrice,
  installPriceMin,
  installPriceMax,
  shopName,
  rating,
  ratingCount,
  shopAddress,
  milesToShop,
  isFirstAvailability,
  appointmentDate,
  isSelected,
  sku,
  selectButtonLabel,
  hideActionButtons,
  ActionsRender,
}) => (
  <Styled.ShopSection id={`install-at-shop-info-${sku}`}>
    <Styled.Header onClick={handleChangeInstallation}>
      <span>Install at Shop</span>
      <InstallAtShopPrice
        isRppEnabled={isRppEnabled}
        installPrice={installPrice}
        installPriceMin={installPriceMin}
        installPriceMax={installPriceMax}
      />
    </Styled.Header>

    <Styled.Appointment onClick={handleChangeInstallation}>
      {appointmentDate}
      {isFirstAvailability && (
      <Styled.Availability>(First Availability)</Styled.Availability>
      )}
    </Styled.Appointment>

    <Styled.ShopName onClick={handleChangeInstallation}>{shopName}</Styled.ShopName>

    <Styled.Rating onClick={handleChangeInstallation}>
      <StarCount ratings={rating} flex />
      <Styled.ShopRatingLabel>
        (
        {ratingCount}
        )
      </Styled.ShopRatingLabel>
    </Styled.Rating>

    <Styled.ShopAddress onClick={handleChangeInstallation}>
      <Styled.ShopMileage>{milesToShop}</Styled.ShopMileage>
      {shopAddress}
    </Styled.ShopAddress>

    <Styled.WarrantyMessage>
      <Styled.WarrantyMessageBold>* Pay for install at the repair shop. </Styled.WarrantyMessageBold>
      All repairs come with a 12-month/12,000-mile service warranty from the installer.
    </Styled.WarrantyMessage>

    {!ActionsRender && !hideActionButtons && (
      <Styled.ButtonsWrapper>
        <ButtonDifmWmo
          id={`add-installation-cta-Checkout-${sku}`}
          icon={isSelected ? <CheckWmoIcon /> : <PlusWmoIcon />}
          label={selectButtonLabel}
          onClick={handleToggleInstallation}
          isSelected={isSelected}
        />
        <ButtonDifmWmo
          id={getInstallAtShopSeeMoreCTAId(sku)}
          label="Edit Appointment"
          onClick={handleChangeInstallation}
        />
      </Styled.ButtonsWrapper>
    )}

    {Boolean(ActionsRender) && ActionsRender}
  </Styled.ShopSection>
)

export default React.memo(InstallAtShopInfoCheckoutWmo)
